<template>
  <Row :divider="showDivider">
    <template #icon-left>
      <StepIndicator
        :icon="icon"
        :is-completed="isCompleted"
        :is-disabled="isDisabled"
      />
    </template>
    <template #top-left>
      <BaseText
        size="p4"
        :style="{ fontWeight: isCurrent ? 600 : 400 }"
        :color="titleColor"
      >
        {{ title }}
      </BaseText>
    </template>
    <template #bottom-left>
      <BaseText size="p5" :color="descriptionColor">
        {{ description }}
      </BaseText>
    </template>
    <template #top-right>
      <ChipStatus
        v-if="status && chipType"
        :status="chipType"
        :label="status"
      />
    </template>
  </Row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Row, BaseText, ChipStatus } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { AccountStateChipType } from '@/modules/common/services/http/account/account-state-types';
import StepIndicator from './StepIndicator.vue';

@Component({
  name: 'AccountStateRow',
  components: {
    Row,
    BaseText,
    ChipStatus,
    StepIndicator
  }
})
export default class AccountStateRow extends Vue {
  public readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Number, required: false })
  public icon?: number;

  @Prop({ type: Boolean, default: false })
  public isCompleted!: boolean;

  @Prop({ type: Boolean, default: false })
  public isCurrent!: boolean;

  @Prop({ type: Boolean, default: false })
  public isDisabled!: boolean;

  @Prop({ type: String, required: true })
  public title!: string;

  @Prop({ type: String, required: true })
  public description!: string;

  @Prop({ type: String, required: false })
  public status?: string;

  @Prop({ type: String, required: false })
  public chipType?: AccountStateChipType;

  @Prop({ type: Boolean, default: true })
  public showDivider!: boolean;

  private get titleColor(): string {
    return this.isDisabled
      ? NebraskaColors.elementDisabled
      : NebraskaColors.elementPrimary;
  }

  private get descriptionColor(): string {
    return this.isDisabled
      ? NebraskaColors.elementDisabled
      : NebraskaColors.textSecondary;
  }
}
</script>
